<template>
    <v-card light>
        <v-card-title>Добавить отчет</v-card-title>
        <v-card-text>
            <v-text-field label="Ссылка" v-model="url" style="margin-bottom: 16px"></v-text-field>

            <v-date-picker v-model="date"></v-date-picker>
        </v-card-text>
        <v-card-actions>
            <div class="flex-md-grow-1"></div>
            <v-btn
                    color="#8a2be2"
                    text
                    @click="closer"
            >
                Отмена
            </v-btn>
            <v-btn
                    color="#8a2be2"
                    text
                    @click="submit"
            >
                Сохранить
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {HTTP} from "../../axios";

    export default {
        props:[
            'closer'
        ],
        name: "ReportAdder",
        data(){
            return{
                date: null,
                url: ""
            }
        },
        methods:{
            submit(){
                if(this.url == ""){
                    alert("Введите ссылку!")
                    return false
                }
                if(this.date == null){
                    alert("Выберите дату!")
                    return false
                }

                var data = {
                    date: this.date,
                    url: this.url
                }
                HTTP
                    .post("reports", JSON.stringify(data), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                    .then(()=>{
                        this.closer()
                    })
            }
        }
    }
</script>

<style scoped>

</style>